import React from 'react';

type ISeatmapContainer = {
  fontFamily: string;
  modal: boolean;
  modalStyle: string;
  children: React.ReactNode;
  brand?: string;
  modalMaxWidth?: string;
};

const GenericSeatmapContainer = ({
  fontFamily,
  modal,
  modalStyle,
  children,
  modalMaxWidth,
}: ISeatmapContainer) => {
  const containerStyle = {
    fontFamily: fontFamily,
    ...(modal && modalMaxWidth && { maxWidth: modalMaxWidth }),
  };

  return (
    <div
      style={containerStyle}
      role="dialog"
      tabIndex={-1}
      aria-label={modal ? 'Seat Selection Dialog' : 'Seat Selection'}
      id="gordian-seatmap-dialog"
      className={`gordian-seatmap gr-text-primary-text ${
        modal
          ? `${modalStyle} gr-w-full sm:gr-w-11/12`
          : 'gordian-embedded gr-w-full'
      }`}
    >
      {children}
    </div>
  );
};

const SeatmapContainer = ({
  fontFamily,
  modal,
  modalStyle,
  children,
  modalMaxWidth,
}: ISeatmapContainer) => {
  return (
    <GenericSeatmapContainer
      fontFamily={fontFamily}
      modal={modal}
      modalStyle={modalStyle}
      modalMaxWidth={modalMaxWidth}
    >
      {children}
    </GenericSeatmapContainer>
  );
};

export default SeatmapContainer;
